// Google Sheets product data configuration
export const GOOGLE_SHEETS_CONFIG = {
  sheetUrl:
    import.meta.env?.VITE_GOOGLE_SHEETS_URL ||
    'https://docs.google.com/spreadsheets/d/1VEpOGOtf05J7Tc9NVlpfRRZSJdOpFy3Ya9RhDs0o49k/gviz/tq?tqx=out:csv',
  fallbackData: false
};

// Mock data based on typical Google Sheets product structure
export const mockProductData = [
  {
    SKU: 'TAT001',
    Nome_Prodotto: 'Tatuaggio Tradizionale Small',
    Descrizione: 'Tatuaggio tradizionale di piccole dimensioni',
    Prezzo: '80.00',
    Categoria: 'Tradizionale',
    Disponibile: 'Sì'
  },
  {
    SKU: 'TAT002',
    Nome_Prodotto: 'Tatuaggio Tradizionale Medium',
    Descrizione: 'Tatuaggio tradizionale di medie dimensioni',
    Prezzo: '150.00',
    Categoria: 'Tradizionale',
    Disponibile: 'Sì'
  },
  {
    SKU: 'TAT003',
    Nome_Prodotto: 'Tatuaggio Tradizionale Large',
    Descrizione: 'Tatuaggio tradizionale di grandi dimensioni',
    Prezzo: '250.00',
    Categoria: 'Tradizionale',
    Disponibile: 'Sì'
  },
  {
    SKU: 'TAT004',
    Nome_Prodotto: 'Tatuaggio Realistico Portrait',
    Descrizione: 'Ritratto realistico in bianco e nero',
    Prezzo: '300.00',
    Categoria: 'Realistico',
    Disponibile: 'Sì'
  },
  {
    SKU: 'TAT005',
    Nome_Prodotto: 'Tatuaggio Geometrico',
    Descrizione: 'Design geometrico moderno',
    Prezzo: '180.00',
    Categoria: 'Geometrico',
    Disponibile: 'Sì'
  },
  {
    SKU: 'TAT006',
    Nome_Prodotto: 'Tatuaggio Lettering',
    Descrizione: 'Scritta personalizzata',
    Prezzo: '120.00',
    Categoria: 'Lettering',
    Disponibile: 'Sì'
  },
  {
    SKU: 'TAT007',
    Nome_Prodotto: 'Cover Up',
    Descrizione: 'Copertura di tatuaggio esistente',
    Prezzo: '200.00',
    Categoria: 'Cover Up',
    Disponibile: 'Sì'
  },
  {
    SKU: 'TAT008',
    Nome_Prodotto: 'Touch Up Session',
    Descrizione: 'Sessione di ritocco per tatuaggio esistente',
    Prezzo: '50.00',
    Categoria: 'Ritocco',
    Disponibile: 'Sì'
  },
  {
    SKU: 'PIR001',
    Nome_Prodotto: 'Piercing Orecchio Standard',
    Descrizione: 'Piercing standard per lobo orecchio',
    Prezzo: '30.00',
    Categoria: 'Piercing',
    Disponibile: 'Sì'
  },
  {
    SKU: 'PIR002',
    Nome_Prodotto: 'Piercing Cartilagine',
    Descrizione: 'Piercing per cartilagine orecchio',
    Prezzo: '45.00',
    Categoria: 'Piercing',
    Disponibile: 'Sì'
  },
  {
    SKU: 'PIR003',
    Nome_Prodotto: 'Piercing Naso',
    Descrizione: 'Piercing per narice o setto nasale',
    Prezzo: '40.00',
    Categoria: 'Piercing',
    Disponibile: 'Sì'
  },
  {
    SKU: 'ACC001',
    Nome_Prodotto: 'Crema Aftercare',
    Descrizione: 'Crema per cura post-tatuaggio',
    Prezzo: '15.00',
    Categoria: 'Accessori',
    Disponibile: 'Sì'
  },
  {
    SKU: 'ACC002',
    Nome_Prodotto: 'Pellicola Protettiva',
    Descrizione: 'Pellicola trasparente per protezione tatuaggio',
    Prezzo: '8.00',
    Categoria: 'Accessori',
    Disponibile: 'Sì'
  },
  {
    SKU: 'ACC003',
    Nome_Prodotto: 'Gift Card 100€',
    Descrizione: 'Buono regalo del valore di 100 euro',
    Prezzo: '100.00',
    Categoria: 'Gift Card',
    Disponibile: 'Sì'
  },
  {
    SKU: 'ACC004',
    Nome_Prodotto: 'Gift Card 200€',
    Descrizione: 'Buono regalo del valore di 200 euro',
    Prezzo: '200.00',
    Categoria: 'Gift Card',
    Disponibile: 'Sì'
  }
];

// Enhanced function to fetch data from Google Sheets
export const fetchProductData = async () => {
  const googleSheetsUrl = GOOGLE_SHEETS_CONFIG.sheetUrl;
  
  if (googleSheetsUrl && googleSheetsUrl?.trim()) {
    try {
      console.log('Fetching data from Google Sheets:', googleSheetsUrl);
      
      const response = await fetch(googleSheetsUrl, {
        method: 'GET',
        headers: {
          'Accept': 'text/csv'
        }
      });
      
      if (!response?.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const csvText = await response?.text();
      console.log('Raw CSV data received:', csvText?.substring(0, 200) + '...');
      
      // Parse CSV data with better error handling
      const lines = csvText?.split('\n')?.filter(line => line?.trim());
      if (lines?.length === 0) {
        throw new Error('CSV file is empty');
      }
      
      const headers = lines?.[0]?.split(',')?.map(h => h?.trim()?.replace(/"/g, '')?.toLowerCase());
      
      console.log('Detected headers:', headers);
      
      const data = // Filter empty rows
      lines?.slice(1)?.filter(line => line?.trim() && !line?.startsWith(',,,'))?.map((line, index) => {
          try {
            // Handle CSV parsing with quoted values
            const values = [];
            let current = '';
            let inQuotes = false;
            
            for (let i = 0; i < line?.length; i++) {
              const char = line?.[i];
              if (char === '"' && (i === 0 || line?.[i-1] === ',')) {
                inQuotes = true;
              } else if (char === '"' && inQuotes && (i === line?.length - 1 || line?.[i+1] === ',')) {
                inQuotes = false;
              } else if (char === ',' && !inQuotes) {
                values?.push(current?.trim()?.replace(/^"|"$/g, ''));
                current = '';
              } else {
                current += char;
              }
            }
            values?.push(current?.trim()?.replace(/^"|"$/g, ''));
            
            const obj = {};
            headers?.forEach((header, index) => {
              obj[header] = values?.[index] || '';
            });
            return obj;
          } catch (err) {
            console.warn(`Error parsing line ${index + 2}:`, line, err);
            return null;
          }
        })?.filter(Boolean);
      
      console.log(`Successfully parsed ${data?.length} products from Google Sheets`);
      return data;
      
    } catch (error) {
      console.error('Error fetching Google Sheets data:', error);
      throw new Error(`Impossibile caricare i dati dal foglio Google: ${error.message}`);
    }
  }
  
  console.warn('No Google Sheets URL configured, using fallback data');
  return mockProductData;
};

// Enhanced transform function to handle expected format: sku, name, Prezzo pubb. iva esc., reseller_price iva esc.
export const transformProductData = (sheetsData) => {
  return sheetsData?.map((item, index) => {
    // Handle multiple possible column name variations
    const sku = item?.sku || item?.SKU || item?.codice || item?.Codice || 
                item?.code || item?.Code || `ITEM_${index + 1}`;
    
    const name = item?.name || item?.Name || item?.nome || item?.Nome || 
                 item?.nome_prodotto || item?.Nome_Prodotto || item?.product || 
                 item?.Product || item?.descrizione || item?.Descrizione || '';
    
    const publicPrice = item?.['prezzo pubb. iva esc.'] || 
                       item?.['Prezzo pubb. iva esc.'] ||
                       item?.publicPrice || item?.public_price ||
                       item?.prezzo_pubblico || item?.prezzo || 
                       item?.price || item?.Price || '0.00';
    
    const resellerPrice = item?.['reseller_price iva esc.'] ||
                         item?.['reseller_price'] || item?.reseller ||
                         item?.prezzo_rivenditore || item?.wholesale ||
                         publicPrice; // fallback to public price
    
    return {
      id: `prod_${index + 1}`,
      sku: sku?.toString(),
      name: name?.toString(),
      description: item?.descrizione || item?.description || '',
      price: publicPrice?.toString()?.replace(',', '.'), // Handle Italian decimal format
      publicPrice: publicPrice?.toString()?.replace(',', '.'),
      resellerPrice: resellerPrice?.toString()?.replace(',', '.'),
      category: item?.categoria || item?.category || 'Generale',
      available: true
    };
  })?.filter(product => product?.sku && product?.name); // Only include products with sku and name
};
